import React from 'react';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import ReportPlayersContent from './ReportPlayersContent';

export default function ReportPlayers() {
  return (
    <CusPageCardContainer title={'Player reports'}>
      <ReportPlayersContent />
    </CusPageCardContainer>
  );
}
